var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29279 8.29303C5.10532 8.48056 5 8.73487 5 9.00003C5 9.26519 5.10532 9.5195 5.29279 9.70703L11.2928 15.707C11.4803 15.8945 11.7346 15.9998 11.9998 15.9998C12.265 15.9998 12.5193 15.8945 12.7068 15.707L18.7068 9.70703C18.8889 9.51843 18.9897 9.26583 18.9875 9.00363C18.9852 8.74143 18.88 8.49062 18.6946 8.30521C18.5092 8.1198 18.2584 8.01464 17.9962 8.01236C17.734 8.01008 17.4814 8.11087 17.2928 8.29303L11.9998 13.586L6.70679 8.29303C6.51926 8.10556 6.26495 8.00024 5.99979 8.00024C5.73462 8.00024 5.48031 8.10556 5.29279 8.29303Z",
    fill: "#7A7E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.b897233e1411685dfa299ea621de7ec7.svg";
export { ForwardRef as ReactComponent };